import { Loading } from '@rd-web-markets/shared/dist/util';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import claimProjectReportsListsService from '@rd-web-markets/shared/dist/services/lists/claim_groups/claim_project_reports_lists.service';

const ClaimProjectReportsSection = ({ claimGroup, accountType }) => {
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);

  const [allReports] = claimProjectReportsListsService.useFetchAll({
    claimGroupId: claimGroup?.id,
    accountType,
    setLoading,
    usePageFromUrl: false,
    updateUrl: false,
  });

  const isComplete = r => {
    return (
      (r.project_name || '').length > 0 &&
      (r.start_date || '').length > 0 &&
      (r.capabilities || '').length > 0 &&
      (r.technical_uncertainties || '').length > 0 &&
      (r.how_and_when_were_uncertainties_overcome || '').length > 0 &&
      (r.why_was_knowledge_sought_not_readily_deducible || '').length > 0
    );
  };

  if (!claimGroup || loading) return <Loading />;

  return (
    <>
      <Card.Body>
        <Card>
          <Card.Body>
            <p>
              Make sure they meet the criteria for R&D set out in the Instructions.
              Your projects don't have to be separate products. You can break down
              one big product into multiple distinct "projects". And remember: your
              audience is non-technical so explain your work simply and clearly.
            </p>
          </Card.Body>
        </Card>
        <Row className="pt-4">
          {(allReports || []).filter(r => r.include_in_technical_report === true).map(report => (
            <Col md={3} key={report.id} className="pb-3">
              <Card>
                <Card.Header className="text-center">
                  {isComplete(report) ? 'Completed' : 'In Progress'}
                </Card.Header>
                <Link to={`technical_proof/project_reports/${report.id}`}>
                  <Card.Body className="text-center">{report.project_name}</Card.Body>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </>
  );
};

export default ClaimProjectReportsSection;
